import { useEffect, useState } from 'react';

import MobileRoadmap from '../components/MobileRoadmap';
import React from 'react';
import RoadmapCard from '../components/RoadmapCard';

const RoadMap = () => {
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1200) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
      return window.addEventListener('resize', handleResize);
    };
    return handleResize();
  });

  return <>{isMobile ? <MobileRoadmap /> : <RoadmapCard />}</>;
};

export default RoadMap;
